import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { DashboardInfoData } from './dashboard-info.types';
import { useGlobalStore } from '@old/global-store/use-store';
import { transformIntoQueryParamString } from '@old/utils/service';

// deprecated service ref.: getDashboardInformation_DEPRECATED

// implementado ✅
export async function dashboardInfoService() {
  const { organizationId } = useGlobalStore.getState();
  const query = transformIntoQueryParamString({ organization_id: organizationId });

  const { response, data } = await BACKEND.get<DashboardInfoData>(ENDPOINT.DASHBOARD_INFO, { query });

  return {
    response,
    summary: data,
  };
}
